import { render, staticRenderFns } from "./GenerateStorageAgreement.vue?vue&type=template&id=8884c036"
import script from "./GenerateStorageAgreement.vue?vue&type=script&lang=js"
export * from "./GenerateStorageAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports